const CartSchema = {
  title: 'Warenkorb Einstellungen',
  fieldsets: [
    {
      id: 'default',
      title: 'Allgemein',
      fields: ['title', 'description'],
    },
  ],
  properties: {
    title: {
      title: 'Titel',
      type: 'string',
    },
    description: {
      title: 'Beschreibung',
      type: 'string',
      widget: 'textarea',
    },
  },
  required: [],
};

export default CartSchema;
